import React from 'react';
import { connectMenu, hideMenu } from 'react-contextmenu';

import { ConfigFlags } from 'services/file.service';
import { useAppDispatch } from 'store/store-hooks';

import { setRemovingInstance } from 'components/app/_mediator/app-data.slice';
import { setSelectedFile } from 'components/app/projects/_mediator/projects.slice';
import { setConfigPanel } from 'components/app/editor/_mediator/editor.slice';

import { ContextMenu, MenuOption, MenuTrigger } from 'components/UI/context-menu/context-menu';

interface MenuData {
  id: string;
  action: ConfigFlags;
  ['data-fileId']: number;
  ['handle-delete']: (e: React.MouseEvent<HTMLDivElement>, data: MenuData, target: HTMLDivElement) => void;
  ['handle-configure']: (e: React.MouseEvent<HTMLDivElement>, data: MenuData, target: HTMLDivElement) => void;
}

interface SelectorFilesMenuTrigger extends React.HTMLAttributes<HTMLDivElement> {
  fileId: FileId;
}

interface MenuModal {
  id: string;
  trigger: MenuData;
}

// C O M P O N E N T S

const MENU_ID = 'media-menu';

const MenuModal = (props: MenuModal) => {
  const { id, trigger } = props;

  const handleDelete = trigger ? trigger['handle-delete'] : undefined;
  const handleConfigure = trigger ? trigger['handle-configure'] : undefined;

  return (
    <ContextMenu id={id}>
      <MenuOption onClick={handleConfigure}>Configure</MenuOption>
      <MenuOption onClick={handleDelete}>Delete</MenuOption>
    </ContextMenu>
  );
};

const SelectorFilesMenuTrigger = ({ fileId, children }: SelectorFilesMenuTrigger) => {
  const dispatch = useAppDispatch();

  const handleDelete = (_: React.BaseSyntheticEvent, data: MenuData) => {
    dispatch(setRemovingInstance({ instance: 'file', modalOpen: true, id: data['data-fileId'] }));
    hideMenu();
  };
  const handleConfigure = (_: React.BaseSyntheticEvent, data: MenuData) => {
    dispatch(setSelectedFile(data['data-fileId']));
    dispatch(setConfigPanel('file'));
    hideMenu();
  };

  return (
    <MenuTrigger
      key={fileId}
      id={MENU_ID}
      data-fileId={fileId}
      handle-delete={handleDelete}
      handle-configure={handleConfigure}
      collect={(props) => props}
    >
      {children}
    </MenuTrigger>
  );
};

export const MediaListMenu = connectMenu(MENU_ID)(MenuModal);
export { SelectorFilesMenuTrigger };
